// extracted by mini-css-extract-plugin
export default {"headingWrapper":"HeadingText__headingWrapper___Qcw1y"};